var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgListSelfRightDark = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 56,
    viewBox: "0 0 16 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H4C10.6274 0 16 5.37258 16 12V44C16 50.6274 10.6274 56 4 56H0V0Z",
    fill: "#044953"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 0C10.6274 0 16 5.37258 16 12V44C16 50.6274 10.6274 56 4 56H0V55H4C10.0751 55 15 50.0751 15 44V41.874C13.2748 41.4299 12 39.8638 12 38V18C12 16.1362 13.2748 14.5701 15 14.126V12C15 5.92487 10.0751 1 4 1H0V0H4Z",
    fill: "#00BFBF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgListSelfRightDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/list_self_right_dark.a4ba376aeee683bc73d9c8a7f5ca8bdf.svg";